if (!customElements.get('ss-review-gallery')) {
  customElements.define('ss-review-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.rail = this.querySelector('.ss-reviews__rail');
      this.dialog = this.querySelector('dialog');
      this.detail = this.querySelector('[data-review-detail]');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.rail || !this.dialog) return;
      this.previous.addEventListener('click', () => this.move(1), { signal });
      this.next.addEventListener('click', () => this.move(-1), { signal });
      this.rail.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
      this.addEventListener('click', (event) => {
        const card = event.target.closest('[data-review-open]');
        if (!card || !this.contains(card)) return;
        const template = [...this.querySelectorAll('template[data-review-content]')].find(item => item.dataset.reviewContent === card.dataset.reviewOpen);
        if (!template) return;
        this.detail.replaceChildren(template.content.cloneNode(true));
        this.readingCard = card;
        card.classList.add('is-reading');
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }, { signal });
      this.querySelector('[data-review-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.restorePage(), { signal });
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.rail);
      this.updateArrows();
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
        }, { signal });
      }
    }
    move(direction) {
      const item = this.rail.querySelector('.ss-reviews__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      this.rail.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateArrows() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const position = Math.abs(this.rail.scrollLeft);
      this.previous.disabled = position < 2;
      this.next.disabled = max - position < 2;
    }
    restorePage() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      this.readingCard?.classList.remove('is-reading');
      this.readingCard?.focus({ preventScroll: true });
      this.readingCard = null;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restorePage();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
